import { toneSoftClasses, type Tone } from "@/lib/tones";
import type { SituacaoOsChave } from "@/types/finance";

const TOM_DA_SITUACAO: Record<SituacaoOsChave, Tone> = {
  aguardando_revisao: "warning",
  confirmada: "info",
  faturada: "success",
  cancelada: "neutral",
};

const FUNDO_DO_TOM: Record<Tone, string> = {
  neutral: "bg-tone-neutral-bg",
  info: "bg-tone-info-bg",
  success: "bg-tone-success-bg",
  warning: "bg-tone-warning-bg",
  danger: "bg-tone-danger-bg",
  accent: "bg-tone-accent-bg",
  ai: "bg-tone-ai-bg",
};

export function coresDaSituacaoOs(chave: SituacaoOsChave): { selo: string; fundo: string } {
  const tom = TOM_DA_SITUACAO[chave];
  return { selo: toneSoftClasses[tom], fundo: FUNDO_DO_TOM[tom] };
}
